import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ProjectStagesGrid from "../../../../../components/ProjectSidebar/ProjectSidebarContent/ProjectSidebarSections/ProjectStagesGrid/ProjectStagesGrid";
import { useGetUser } from "../../../../../components/UserProfileSetting/hooks/userProfileHelper.hooks";
import { getProjectDetails } from "../../../../services/projects.service";

/**
 * BoardStagesSection component for My Board Stages section
 * Displays project stages grid
 * @author Bhavana
 */
const BoardStagesSection = () => {
  const user = useGetUser();
  const { myProjectId } = user;
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      await dispatch(getProjectDetails({ projectId: myProjectId, userId: user.id, companyId: user.companyId }));
    })();
  }, [myProjectId, user.id, user.companyId]);

  return (
    <div className='profile-section-content bg-light'>
      <ProjectStagesGrid projectId={myProjectId} />
    </div>
  );
};

export default BoardStagesSection;
